import { createRuleData, deleteRuleData } from '@wix/ambassador-promote-accessibility-v1-accessibility-report/http';
import { useErrorHandler, useHttpClient } from '@wix/fe-essentials/react';
import { useMutation } from '@wix/fe-essentials/react-query/react';
import { PanoramaTransactions } from '../panorama/constants';
import { usePanoramaFunctions } from '../panorama/use-panorama-functions';
export const useRuleListDataMutation = () => {
  const httpClient = useHttpClient();
  const errorHandler = useErrorHandler();
  const {
    withErrorHandler
  } = errorHandler;
  const {
    finishPanoramaTransaction,
    startPanoramaTransaction
  } = usePanoramaFunctions();
  return useMutation({
    mutationFn: async ruleData => {
      startPanoramaTransaction(PanoramaTransactions.suppressIncompleteElement, ruleData);
      await withErrorHandler(async () => httpClient.request(ruleData.delete ? deleteRuleData(ruleData) : createRuleData({
        ruleData
      })), {
        errorCodesMap: {}
      });
      finishPanoramaTransaction(PanoramaTransactions.suppressIncompleteElement, ruleData);
    }
  });
};
//# sourceMappingURL=use-rule-list-data-mutation.js.map